<template>
  <div class="bg-white rounded p-md-3 px-md-4">
    <div class="row mt-3">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-clock text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Historial de solicitud
        </span>
      </div>
    </div>
    <custom-result-not-found v-if="items.length === 0" />
    <time-line class="mt-4">
      <div v-for="(item, index) in items" :key="`item-index-${index}`">
        <time-line-item class="custom-time-line rounded">
          <template #icon>
            <em class="radius fas fa-exchange-alt text-white" />
          </template>
          <template #date>
            <div class="date-container">
              <div class="text-color-gray font-12 fulldate text-right">
                Fecha:
              </div>
              <div
                class="color-black font-16 font-weight-bold fulldate text-right"
              >
                {{ item.date | date }}
              </div>
              <div class="color-black font-16 font-weight-bold hour text-right">
                {{ item.date | hour }}
              </div>
            </div>
          </template>
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-lg-2 position-relative">
                  <p
                    class="font-18 font-weight-bold position-absolute title-pop"
                  >
                    Cambio de Estatus
                  </p>
                </div>
                <div class="col-12 col-lg-3">
                  <label class="font-14 text-color-gray">
                    Nombre de Usuario:
                  </label>
                  <p class="font-16">{{ item.userName | empty }}</p>
                </div>
                <div class="col-12 col-lg-3">
                  <label class="font-14 text-color-gray">Estatus::</label>
                  <p class="font-16">
                    <i
                      class="fas fa-circle mr-2 font-12"
                      :class="statusColor(item.statusId)"
                    />
                    {{ item.statusName }}
                  </p>
                </div>
              </div>
            </div>
            <div v-if="hasDescription(item)" class="col-12">
              <div class="bg-white rounded py-2 px-4">
                <label class="font-14 text-color-gray">
                  <i class="fas fa-info-circle text-orange mr-2" />
                  Descripción:
                </label>
                <p>{{ item.reason | empty }}</p>
              </div>
            </div>
          </div>
        </time-line-item>
      </div>
    </time-line>
    <div
      v-if="showButton"
      class="d-flex justify-content-center align-items-center mt-3"
    >
      <action-button
        class="btn-see-more"
        i="fas fa-chevron-down"
        text="Ver más"
        variant="outline-success rounded-pill px-5"
        @click="$emit('on-load-more')"
      />
    </div>
  </div>
</template>

<script>
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import companyDeterminationStatus from '@/utils/constants/companyDeterminationStatus.js';

export default {
  name: 'ProviderApprovalHistory',
  components: {
    TimeLine,
    TimeLineItem,
    CustomResultNotFound,
    ActionButton,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    showButton: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    statusColor() {
      return (statusId) => {
        switch (statusId) {
          case companyDeterminationStatus.Nuevo:
            return 'dot-gray';
          case companyDeterminationStatus.DocumentosSometidos:
            return 'dot-yellow';
          case companyDeterminationStatus.Denegado:
            return 'dot-red';
          case companyDeterminationStatus.Aprobado:
            return 'dot-green';
          default:
            break;
        }
      };
    },
    hasDescription() {
      return (item) => {
        return item.reason?.length > 0;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/shared/scss/config/_colors.scss';
.title-pop {
  top: 20%;
  left: 5%;
}

.text-color-gray {
  color: map-get($colors, 'gray-6');
}

.dot-gray {
  color: map-get($colors, 'gray');
}
.dot-yellow {
  color: map-get($colors, 'yellow');
}
.dot-green {
  color: #a3e5b3;
}
.dot-red {
  color: map-get($colors, 'red');
}

::v-deep .timeline__content--inner {
  margin-left: 1rem;
}
</style>
